export default "__VITE_ASSET__BoI4rslr__"